import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ClusterGroup } from './ClusterGroupPicker';

export const ClusterGroupPickerExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'ClusterGroupPicker',
        component: ClusterGroup,
    }),
);
